if (!process.env.REACT_APP_API_ENDPOINT) {
  throw new Error("API endpoint not found");
}

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const GOOGLE_RECAPTCHA_SITE_KEY =
  "6Ldl_rIfAAAAAAc0Yy12T_9n7JUT2SXTF8F3CYWF";
export const ALCHEMY_API_KEY = "3MyV1e7FBgSJd_HS0kglrFYmdsanNVse";
export const THIRDWEB_CLIENT_ID = "18671ff715af4d3b601261bfe620accb";
